import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate"

Vue.use(Vuex)
const store = new Vuex.Store({
    // plugins: [createPersistedState()],
    plugins: [
        //  vuex-persistedstate默认使用localStorage来固化数据，但是有的情况需要在浏览器窗口关闭时清除数据，所以需要设为sessionStorage保存
        createPersistedState({
            storage: window.sessionStorage
        })
    ],
    state: {
        hasLogin: false,//用户登录状态
        loginData: {},
        userInfo: {},
        loginInfo: {},
        token: '',
        city: {
            name: '重庆',
            code: 500000
        },
        domainInfoCity: {
            abridge: "",
            code: 0,
            h5: "",
            name: "",
            pCode: 0,
            pName: "",
            policy_cid: 0,
            prefix: "",
            pShort_name: "",
            short_name: "",
            wx: "",
        },
        locationInfo: {
            id: 500000,
            lat: 29.533155,
            level: 1,
            lng: 106.504959,
            name: "重庆",
            pid: 0,
            short_name: "重庆"
        },
        setPositioning: {
            id: 500000,
            lat: 29.533155,
            level: 1,
            lng: 106.504959,
            name: "重庆",
            pid: 0,
            short_name: "重庆"
        },
        chatRecord: [],
        chatUserInfo: [],
        childCodes: [],
        childNode:{},
    },
    mutations: {
        //设置登录用户信息
        SET_LOGIN(state, loginInfo) {
            state.hasLogin = true;
            state.loginData = loginInfo;
            state.token = loginInfo.token;
            sessionStorage.setItem("token", loginInfo.token);
            localStorage.setItem("token", loginInfo.token);
            sessionStorage.setItem("loginData", JSON.stringify(loginInfo));
        },
        /*设置用户信息*/
        SET_USERINFO(state, user_data) {
            state.userInfo = user_data;
            state.token = user_data.token;
            sessionStorage.setItem("token", user_data.token);
            localStorage.setItem("token", user_data.token);
            localStorage.setItem("userInfo", JSON.stringify(user_data));
        },
        //给token赋值
        SET_TOKEN: (state, token) => {
            state.token = token;
            sessionStorage.setItem("token", token);
            localStorage.setItem("token", token);
        },
        //移除用户信息
        REMOVE_INFO: (state) => {
            state.token = "";
            state.hasLogin = false;
            state.loginData = {};
            state.userInfo = {};
            sessionStorage.setItem("token", "");
            localStorage.setItem("token", "");
            sessionStorage.setItem("loginData", JSON.stringify(""));
            sessionStorage.setItem("userInfo", JSON.stringify(""));
        },
        // 改变城市时
        changeCity(state, info) {
            state.city.name = info.name
            state.city.code = info.code
        },
        /*插入新的聊天记录-当前打开的对话框*/
        SET_CHAT(state, info) {
            state.chatRecord.push(info)
        },
        SET_ChatMessage(state, info) {
            if (info.roomId == state.chatRecord.roomId) {
                state.chatRecord.chatProject.push(info)
                state.chatRecord.chatProject.sort(function (a, b) {
                    return (a.time - 0) - (b.time - 0)
                })
            } else {
                state.chatUserInfo.forEach(function (item) {
                    if (item.roomId == info.roomId) {
                        item.newMsgTotal++;
                        item.chatProject.push(info);
                    }
                })
            }
        },
        SetChatUser(state, info) {
            if (state.chatUserInfo.length > 0) {
                function findRoom(row) {
                    return row.roomId === info.roomId;
                }

                if (state.chatUserInfo.find(findRoom)) {
                } else {
                    state.chatUserInfo.push(info)
                }
            } else {
                state.chatUserInfo.push(info)
            }
        },
        SET_ChildNodes(state, info) {
            console.log(info);
            state.childNodes = JSON.parse(info);
            sessionStorage.setItem("childNodes", info);
            localStorage.setItem("childNodes", info);
        },
        SET_CHILD_NODE(state,node){
            state.childNode = JSON.parse(node);
            sessionStorage.setItem("childNode", node);
            localStorage.setItem("childNode", node);
        }
    },
    actions: {},
    modules: {}
})
export default store